import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { resolvePath } from '@/utils/resolvePath';
import { imageLoader } from '@/utils/imageLoader';
import { fetchVehicleInfo } from '@/components/fakeDoor/api';
import Router from '@/components/common/router';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_BTN_RESUME_BOOKING_MODAL } from '@/analytics/events';
import { APPOINTMENT_CARD_TYPE } from '@/constants/enums';
import { formatBookingDetails } from '@/components/fakeDoor/utils';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import RightArrowIcon from '@/assets/Icons/Arrow_right.svg';
import {
    UserCardWrapper,
    UserCardContainer,
    VehicleCardDetailsWrapper,
    UserWelcomeHeadingWrapper,
    ContinueText,
    VehicleDetailsWrapper,
    VehicleDetailsContainer,
    VehicleDetailsTextContainer,
    VehicleImageContainer,
    VehicleName,
    VehicleNumber,
    ArrowIconWrapper,
    ButtonWrapper,
    ButtonText,
} from './styles';
import { USER_CARD_MESSAGES } from './messages';

const ResumeBookingCard = ({ cardData }: { cardData: any }) => {
    const [imageData, setImageData] = useState('');
    const { navigatePath, paymentLink } = cardData;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const visData = await fetchVehicleInfo(
                    cardData?.vehicleDetails?.model_id as number
                );
                setImageData(JSON.parse(visData));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (cardData?.vehicleDetails?.model_id) {
            fetchData();
        }
    }, [cardData?.vehicleDetails?.model_id]);

    const handleClick = () => {
        trackEventAPI({
            event_name: TAP_BTN_RESUME_BOOKING_MODAL,
            customAttributes: {
                model_id: cardData?.vehicleDetails?.model_id,
                vehicle_make: cardData?.vehicleDetails?.make,
                vehicle_model: cardData?.vehicleDetails?.model,
                variant: cardData?.vehicleDetails?.variant_name,
                fuel_type:
                    cardData?.vehicleDetails?.fuel_type?.toLocaleUpperCase(),
                ...formatBookingDetails(cardData?.booking),
            },
            isFakeDoor: true,
        });

        if (cardData.cardType === APPOINTMENT_CARD_TYPE.CONTACT_US) {
            window.open(navigatePath, '_self');
        } else {
            if (paymentLink) {
                window.location.href = paymentLink;
            } else {
                Router.push(navigatePath);
            }
        }
    };

    const renderVehicleDetails = () => (
        <VehicleCardDetailsWrapper isUpcomingBooking={false}>
            <VehicleDetailsWrapper>
                <VehicleImageContainer>
                    <Image
                        loader={imageLoader}
                        src={
                            imageData ||
                            resolvePath(USER_CARD_MESSAGES.DEFAULT_CAR_IMAGE)
                        }
                        width={114}
                        height={66}
                        alt={USER_CARD_MESSAGES.CAR_IMAGE_ALT}
                    />
                </VehicleImageContainer>
                <VehicleDetailsContainer>
                    <VehicleDetailsTextContainer>
                        <VehicleName>
                            {cardData?.vehicleDetails?.make}{' '}
                            {cardData?.vehicleDetails?.model}
                        </VehicleName>
                        <VehicleNumber>
                            {cardData?.vehicleDetails?.registration_number}
                        </VehicleNumber>
                    </VehicleDetailsTextContainer>

                    <ArrowIconWrapper>
                        <RightArrowIcon />
                    </ArrowIconWrapper>
                </VehicleDetailsContainer>
            </VehicleDetailsWrapper>
            <ButtonWrapper onClick={() => handleClick()}>
                <ButtonText>{cardData?.ctaName}</ButtonText>
            </ButtonWrapper>
        </VehicleCardDetailsWrapper>
    );

    return (
        <UserCardWrapper>
            <UserWelcomeHeadingWrapper>
                <ContinueText>
                    {USER_CARD_MESSAGES.RESUME_BOOKING_TITLE}
                </ContinueText>
            </UserWelcomeHeadingWrapper>
            <UserCardContainer>{renderVehicleDetails()}</UserCardContainer>
        </UserCardWrapper>
    );
};

export default ResumeBookingCard;
